import { embedLocation } from "#/shared/lib/embed-location";

const ABSOLUTE_URL = /^(?:[a-z][a-z\d+.-]*:|\/\/)/i;

/**
 * Navigates the page to `url`, as `window.location.assign` does. `location` is
 * unforgeable, so this module is the seam a spec mocks to observe navigation.
 * A relative `url` resolves against the page's own address (`embedLocation`), never a `<base href>`.
 *
 * @param {string} url
 * @param {Window} [view]
 */
export function navigateTo(url, view = window) {
  const target = ABSOLUTE_URL.test(url) ? url : new URL(url, embedLocation(view)).href;
  view.location.assign(target);
}
